<template>
	<div class="tq-sensitive-wrapper" @click.stop="toggleShowPassword" v-loading="loading">
		<div class="left-icon" v-if="needUnlock">
			<img src="./icon_display.svg" v-if="isShow" alt="查看">
			<img src="./icon_hidden.svg" v-else alt="关闭">
		</div>
		<div class="right-text">
			<span>{{ currentInfo.maskingtext }}</span>
		</div>
		<tq-dialog header="敏感数据访问提示" width="600px" class="tq-sensitive-tip-dialog" :close-on-click-modal="false"
			hiddenConfirm hiddenCancel
			append-to-body v-model="dialogVisible">
			<div class="tip-sensitive">
				<span v-if="tipType === 1">根据<a class="href-link-sensitive" target="_blank"
						href="https://oa.feishu.cttq.com/announcement/detail/7309405833762291881?from=from_parent_sheet">《正大天晴药业集团数据权限管理规范》</a>中数据安全使用的要求，您对所有数据的访问行为都会被记录，禁止进行任何非必要的数据导出、截图、拍照、传播。如引起数据泄露，一切后果自行承担!</span>
				<span v-if="tipType === 2">根据数据安全使用的要求，您对所有数据的访问行为都会被记录，禁止进行任何非必要的数据导出、截图、拍照、传播。如引起数据泄露，一切后果自行承担!
				</span>
				<div class="not-show-in-24hour">
					<div class="left-checkbox">
						<el-checkbox v-model="isChecked" @change="setNotShowIn24Hour"></el-checkbox>
					</div>
					<div class="right-text">
						<span>24小时内不再展示</span>
					</div>
				</div>
			</div>
			<template #footer>
				<div class="count-down-sensitive">
					<span>{{ countDownSecondOrigin }}秒后自动关闭</span>
				</div>
			</template>
		</tq-dialog>
	</div>
</template>

<script lang="ts" setup>
import { ref, reactive, watch } from "vue";
import { ElMessage } from "element-plus";
import { getCipherText } from "../../../service/local";
import { setNotShowIn24HourHook } from "./setNotShowIn24Hour";
import TqDialog from "../../Dialog/src/main.vue"

interface Props {
	url: string;
	baseUrl: string;
	encryptInfo?: {
		ciphertext: string;
		maskingtext: string;
	};
	emptyTip?: string;
	needUnlock?: boolean;
	headers?: any;
	maskingType?: number; // 0 默认 展示明文 1 展示切换后的密文
	tipType?: number; // 1天晴，2非天晴
	countDownSecond?: number;
}
const props = withDefaults(defineProps<Props>(), {
	url: "",
	baseUrl: "",
	needUnlock: true,
	maskingType: 0,
	tipType: 1,
	headers: {},
	countDownSecond: 5,
	emptyTip: "暂时无数据",
	encryptInfo: () => ({
		ciphertext: "",
		maskingtext: "",
	}),
});

const isShow = ref<boolean>(false);
const loading = ref(false);

let currentInfo = reactive({
	ciphertext: "",
	maskingtext: "",
});

watch(
	() => props.encryptInfo,
	(newValue, oldValue) => {
		isShow.value = false;
		currentInfo = { ...newValue };
	},
	{ deep: true, immediate: true }
);

const toggleShowPassword = () => {
	if (!props.needUnlock) {
		return;
	}
	if (isShow.value) {
		currentInfo.maskingtext = props.encryptInfo.maskingtext;
		isShow.value = false;
	} else {
		loading.value = true;
		console.log('props.maskingTyp', props.maskingType, judgeIsNotShowIn24Hour());
		
		if (+props.maskingType === 0 && !judgeIsNotShowIn24Hour()) {
			console.log('lllll');
			
			dialogVisible.value = true;
		}
		getCipherText(
			props.url,
			{
				encryptInfo: [currentInfo.ciphertext],
				maskingType: props.maskingType || 0, // 0 默认展示明文 1 展示切换后的密文
			},
			props.baseUrl,
			props.headers
		)
			.then((res: any) => {
				if (res.msgCode == "100" || res.code == "100") {
					const info = res.responseData || res.data || {};
					const decryptInfo = (info.decryptInfo || [])[0] || {};
					currentInfo.maskingtext =
						decryptInfo.plaintext || props.emptyTip;
					isShow.value = true;
				} else {
					ElMessage.error(
						res.message || res.msg || "获取失败，请重试"
					);
				}
			})
			.catch((res) => {
				ElMessage.error(res.message || res.msg || "网络错误，请重试");
			})
			.finally(() => {
				loading.value = false;
			});
	}
};

const { dialogVisible, countDownSecondOrigin, isChecked, judgeIsNotShowIn24Hour, setNotShowIn24Hour } = setNotShowIn24HourHook(props.countDownSecond);
defineOptions({
	name: "TqSensitive",
});
</script>
